// src/app/actions/checklistsReducer.js
import {
  FETCH_CHECKLISTS_REQUEST,
  FETCH_CHECKLISTS_SUCCESS,
  FETCH_CHECKLISTS_FAILURE,
  CREATE_CHECKLIST_REQUEST,
  CREATE_CHECKLIST_SUCCESS,
  CREATE_CHECKLIST_FAILURE,
  UPDATE_CHECKLIST_REQUEST,
  UPDATE_CHECKLIST_SUCCESS,
  UPDATE_CHECKLIST_FAILURE,
  DELETE_CHECKLIST_REQUEST,
  DELETE_CHECKLIST_SUCCESS,
  DELETE_CHECKLIST_FAILURE
} from './checklists'

const initialState = {
  checklists: [],
  isLoading: false,
  error: null
}

export default function checklistsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CHECKLISTS_REQUEST:
    case CREATE_CHECKLIST_REQUEST:
    case UPDATE_CHECKLIST_REQUEST:
    case DELETE_CHECKLIST_REQUEST:
      return { ...state, isLoading: true, error: null }

    case FETCH_CHECKLISTS_SUCCESS:
      return { ...state, isLoading: false, checklists: action.payload }

    case CREATE_CHECKLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        checklists: [action.payload, ...state.checklists]
      }

    case UPDATE_CHECKLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        checklists: state.checklists.map(c =>
          c._id === action.payload._id ? action.payload : c
        )
      }

    case DELETE_CHECKLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        checklists: state.checklists.filter(c => c._id !== action.payload)
      }

    case FETCH_CHECKLISTS_FAILURE:
    case CREATE_CHECKLIST_FAILURE:
    case UPDATE_CHECKLIST_FAILURE:
    case DELETE_CHECKLIST_FAILURE:
      return { ...state, isLoading: false, error: action.payload }

    default:
      return state
  }
}